import styled from 'styled-components';

interface StyledGlobalHeaderProps {
  revealHeader?: boolean;
}

export const StyledGlobalHeader = styled.div<StyledGlobalHeaderProps>`
  position: relative;
  z-index: ${({ revealHeader }) => (revealHeader ? 10001 : 'auto')};
  transition: z-index 0s;

  .tenantStyle {
    height: 130px !important;
  }
`;
